import { render, staticRenderFns } from "./PriceShiftWindows.vue?vue&type=template&id=1127107d&"
import script from "./PriceShiftWindows.vue?vue&type=script&lang=js&"
export * from "./PriceShiftWindows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports